import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import axios from 'axios';
import { mainurl } from '../../MainUrl';

import { Row, Col, Card, CardBody, Input, Button, Label } from 'reactstrap';

const CreateCustomer = () => {
  const [formData, setFormData] = useState({
    customer_name: '',
    ph_no: '',
    email: ''
  });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    setMessage(''); // Clear any previous message

    const customerData = { 
      customer_name: formData.customer_name, 
      ph_no: formData.ph_no,
      email: formData.email
    };

    try {
      const response = await axios.post(mainurl + 'insert_customer', customerData);
      toast.success('Customer created successfully!');
      
      setFormData({ customer_name: '', ph_no: '', email: '' });
    } catch (error) {
      if (error.response) {
        setMessage(error.response.data.message || 'Error occurred');
        setError(error.response.data.message);
      } else {
        setMessage('Network error, please try again later');
        setError('Network error, please try again later');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          <Col xs={12} className="mb-3">
            <Title pageTitle="Add New Customer" />
          </Col>
          <Col xs={12}>
            <Card color="primary" outline className="mb-3">
              <CardBody>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                {success && <p style={{ color: 'green' }}>{success}</p>}
                {message && <p>{message}</p>}

                <Row className="my-2">
                  <Col md={6}>
                    <Label>Customer Name</Label> {/* Changed from Vendor Name to Customer Name */}
                    <Input
                      type="text"
                      name="customer_name"
                      value={formData.customer_name}
                      onChange={handleChange}
                      placeholder="Enter Customer Name"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <Label>Phone Number</Label>
                    <Input
                      type="text"
                      name="ph_no"
                      value={formData.ph_no}
                      onChange={handleChange}
                      placeholder="Enter Phone Number"
                      required
                    />
                  </Col>
                </Row>
                <Row className="my-2">
                  <Col md={6}>
                    <Label>Email</Label>
                    <Input
                      type="text"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter Email"
                      required
                    />
                  </Col>
                </Row>

                <Button color="primary" onClick={handleSubmit} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
};

export default CreateCustomer;
